var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransactionSucceeded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57994 7.58376C3.37994 7.58376 3.18994 7.50376 3.04994 7.36376L0.219941 4.53376C-0.0700586 4.24376 -0.0700586 3.76376 0.219941 3.47376C0.509941 3.18376 0.989941 3.18376 1.27994 3.47376L3.57994 5.77376L8.71994 0.63376C9.00994 0.34376 9.48994 0.34376 9.77994 0.63376C10.0699 0.92376 10.0699 1.40376 9.77994 1.69376L4.10994 7.36376C3.96994 7.50376 3.77994 7.58376 3.57994 7.58376Z",
    fill: "#2BFAAF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSucceeded);
export default __webpack_public_path__ + "static/media/transactionSucceeded.87ff72a64b3d9f4e105c78ce9bbcaedd.svg";
export { ForwardRef as ReactComponent };